import {
  BookingApiServiceApi,
  Configuration,
} from '@ennismore/booking-api-client';
import type { AxiosError } from 'axios';
import { ZodError } from 'zod';

import { axios } from '@/api/axios-instance';
import { getClientHeaders } from '@/api/headers';
import { buildBaseUrl } from '@/api/helpers/build-base-url';
import { EnnismoreAPIClientConfig } from '@/api/interfaces';

import { parseOHIPAxiosError } from './errors';

/**
 * Parent of all Booking API services.
 * Handles setting up of client + common request options.
 */
export abstract class OHIPBookingAPIBaseService {
  protected client: BookingApiServiceApi;

  protected get options() {
    return {
      headers: {
        'x-api-key': this.credentials.apiKey,
        'x-skip-redirect': this.credentials.skipRedirect ? 'true' : undefined,
        ...getClientHeaders(this.credentials),
      },
    };
  }

  constructor(private readonly credentials: EnnismoreAPIClientConfig) {
    const baseUrlWithoutV2 = credentials.baseUrl.replace('/v2', '');

    // OHIP Booking API is the same URL as OWS, minus the version number.
    // We should flip this behaviour when we switch to OHIP-dominant approach.
    const config = new Configuration({
      basePath: buildBaseUrl(baseUrlWithoutV2, {
        servicePrefix: 'booking',
        dialect: 'ohip',
      }),
    });

    this.client = new BookingApiServiceApi(config, undefined, axios);
  }

  protected parseError(error: AxiosError<unknown> | ZodError) {
    return parseOHIPAxiosError(error);
  }
}
